import { render, staticRenderFns } from "./BSTable.vue?vue&type=template&id=0f1bbdf0&scoped=true"
import script from "./BSTable.vue?vue&type=script&lang=js"
export * from "./BSTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1bbdf0",
  null
  
)

export default component.exports